import React, { Component } from 'react';
import { LocaleProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import config from 'react-global-configuration';
import './App.less';
import AppLocale from './languageProvider';
import { connect } from 'react-redux';
import * as actionCurrentUser from './redux/currentUser/actions';
import { loadProgressBar } from 'axios-progress-bar';
import 'axios-progress-bar/dist/nprogress.css';
import appAxios from './axios/appAxios';
import IntlGlobalProvider from './components/InilGlobalProvider/IntlGlobalProvider'
import DefaultLayout from './containers/DefaultLayout/DefaultLayout';
import AuthLogout from './containers/Auth/LogOut';
import env from './env-config';

class App extends Component {
    constructor(props) {
        super(props)

        let langMsg = this.props.language === 'en' ? config.get("langEn") : config.get("langTh");
        let currentAppLocale = AppLocale[this.props.language];

        this.state = {
            langMsg,
            currentAppLocale
        }

        loadProgressBar({
            minimum: 0.9999999,
            trickle: false,
            speed: 400,
            //parent: '#mainLayout',
        }, appAxios);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.language !== nextProps.language) {

            let langMsg = nextProps.language === 'en' ? config.get("langEn") : config.get("langTh");
            let currentAppLocale = AppLocale[nextProps.language];

            this.setState({
                langMsg,
                currentAppLocale
            }, () => {
                this.forceUpdate();
            });
        }
    }

    render() {
        return (
            <LocaleProvider locale={this.state.currentAppLocale.antd}>
                <IntlProvider locale={this.state.currentAppLocale.locale} messages={this.state.langMsg}>
                    <IntlGlobalProvider>
                        <BrowserRouter basename={env.REACT_APP_BASE_NAME}>
                            <Switch>
                                <Route path="/auth/logout" name="Log Out" component={AuthLogout} />
                                <Route path="/" name="DefaultLayout" component={DefaultLayout} />
                            </Switch>
                        </BrowserRouter>
                    </IntlGlobalProvider>
                </IntlProvider>
            </LocaleProvider>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.LanguageSwitcher.language
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setUser: (payload) => dispatch({ type: actionCurrentUser.SET_USER, payload: payload })
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
